export const SITE = {
    name: "TECNO-LAV",
    tagline: "Lavorazioni meccaniche e metalmeccaniche",
    phoneDisplay: "039 9273259",
    phoneHref: "tel:+390399273259",
    email: "Tecnosteel@gmail.com",
    emailHref: "mailto:Tecnosteel@gmail.com",
    address: "Via per Airuno 19 interno 12, 23883 Brivio (LC)",
    city: "Brivio (LC), Lombardia, Italia",
    vat: "P.IVA 03741890135",
    mapsLink: "https://maps.app.goo.gl/DVrXQdqjWvBEBXik8",
    mapsEmbed:
        "https://maps.google.com/maps?q=Tecno-Lav%2C%20Via%20per%20Airuno%2019%2C%2023883%20Brivio%20LC&ll=45.7487539%2C9.438761&t=&z=16&ie=UTF8&iwloc=&output=embed",
};

export const NAV = [
    { id: "home", label: "Home" },
    { id: "azienda", label: "Azienda" },
    { id: "lavorazioni", label: "Lavorazioni" },
    { id: "attrezzature", label: "Attrezzature" },
    { id: "galleria", label: "Galleria", to: "/galleria" },
    { id: "contatti", label: "Contatti" },
];

// Foto reali dell'officina TECNO-LAV (in /public/assets).
export const IMAGES = {
    hero: "/assets/hero.jpg",
    azienda: "/assets/azienda.jpg",
    officina: "/assets/officina.jpg",
};
